import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/layout/Layout';
import HomePageSkeleton from './components/common/HomePageSkeleton';
import { ErrorBoundary, ToastProvider } from '@lab39/react-ui';
import { icons } from './data/icons';
import '@lab39/react-ui/dist/react-ui.css';
import './App.css';

const Home = lazy(() => import('./pages/Home'));
const NotFound = lazy(() => import('./pages/error/NotFound'));
const ServerError = lazy(() => import('./pages/error/ServerError'));

function App() {
  return (
    <ThemeProvider>
      <ErrorBoundary>
        <ToastProvider
          icons={{
            success: icons.success,
            error: icons.error,
            warning: icons.warning,
            info: icons.info
          }}
        >
          <Layout>
            <Suspense fallback={<HomePageSkeleton />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/error" element={<ServerError />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </Layout>
        </ToastProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
